import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isDisabled", "id", "assetId", "variant", "subtitles", "onChange"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import FormField from 'components/FormField';
import Stack from 'components/Stack';
import { Grid, GridItem } from 'components/Grid';
import Text from 'components/Text';
import Button from 'components/Button';
import SubtitlesItem from 'components/SubtitlesItem';
import SubtitlesEditor from 'components/SubtitlesEditor';
import { TYPE_SUBTITLES } from 'utils/file/types';
import { useUploadFile } from 'actions/file';
import { useUpdateSubtitleLanguage } from 'actions/subtitles';
import { setAlert } from 'actions/alerts';
import useUniqueId from 'hooks/useUniqueId';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SubtitlesField = function SubtitlesField(_ref) {
  var isDisabled = _ref.isDisabled,
    id = _ref.id,
    assetId = _ref.assetId,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'transparent' : _ref$variant,
    subtitles = _ref.subtitles,
    onChange = _ref.onChange,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var uniqueId = useUniqueId(id);
  var _useUploadFile = useUploadFile({
      onSetAlert: function onSetAlert(options) {
        return setAlert(_objectSpread({
          key: 'upload-subtitle',
          title: t('alert_uploading_subtitle_file')
        }, options));
      }
    }),
    uploadFile = _useUploadFile.uploadFile;
  var _useUpdateSubtitleLan = useUpdateSubtitleLanguage(),
    updateSubtitleLanguage = _useUpdateSubtitleLan.updateSubtitleLanguage;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasCreateSubtitlesDialog = _useState2[0],
    setHasCreateSubtitlesDialog = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedSubtitleId = _useState4[0],
    setSelectedSubtitleId = _useState4[1];
  var selectedSubtitle = selectedSubtitleId !== null && subtitles.find(function (file) {
    return file.id === selectedSubtitleId;
  });
  var addSubtitles = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
      var file, language, _yield$uploadFile, subtitlesId, newFile, updatedSubtitles, _t;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            file = _ref2.file, language = _ref2.language;
            _context.prev = 1;
            _context.next = 2;
            return uploadFile({
              file: file,
              referenceId: assetId,
              type: TYPE_SUBTITLES,
              language: (language === null || language === void 0 ? void 0 : language.trim()) || 'en-GB',
              skipPostProcessing: true
            });
          case 2:
            _yield$uploadFile = _context.sent;
            subtitlesId = _yield$uploadFile.subtitlesId;
            if (subtitlesId) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return");
          case 3:
            newFile = {
              id: subtitlesId,
              locale: language,
              filename: file.name
            };
            updatedSubtitles = [].concat(_toConsumableArray(subtitles), [newFile]);
            onChange(updatedSubtitles);
            _context.next = 5;
            break;
          case 4:
            _context.prev = 4;
            _t = _context["catch"](1);
            setAlert({
              title: t('alert_upload_subtitle_file_error'),
              message: _t.message
            });
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 4]]);
    }));
    return function addSubtitles(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var updateSubtitles = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref4) {
      var id, language, filteredSubtitles, fileToUpdate, updatedFile, updatedSubtitles, _t2;
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            id = _ref4.id, language = _ref4.language;
            _context2.prev = 1;
            _context2.next = 2;
            return updateSubtitleLanguage({
              subtitleId: id,
              language: language
            });
          case 2:
            filteredSubtitles = subtitles.filter(function (file) {
              return file.id !== id;
            });
            fileToUpdate = subtitles.find(function (file) {
              return file.id === id;
            });
            updatedFile = {
              id: id,
              locale: language,
              filename: fileToUpdate === null || fileToUpdate === void 0 ? void 0 : fileToUpdate.filename
            };
            updatedSubtitles = [].concat(_toConsumableArray(filteredSubtitles), [updatedFile]);
            onChange(updatedSubtitles);
            _context2.next = 4;
            break;
          case 3:
            _context2.prev = 3;
            _t2 = _context2["catch"](1);
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1, 3]]);
    }));
    return function updateSubtitles(_x2) {
      return _ref5.apply(this, arguments);
    };
  }();
  var removeSubtitle = function removeSubtitle(file) {
    var updatedSubtitles = subtitles.filter(function (subtitle) {
      return subtitle.id !== file.id;
    });
    onChange(updatedSubtitles);
  };
  return /*#__PURE__*/_jsxs(FormField, _objectSpread(_objectSpread({
    label: t('content_type_video_subtitles'),
    labelId: uniqueId
  }, otherProps), {}, {
    children: [/*#__PURE__*/_jsxs(Stack, {
      spacing: "xs",
      children: [!subtitles.length && /*#__PURE__*/_jsx(Text, {
        as: "p",
        dimmed: true,
        size: "s",
        children: t('alert_no_subtitles_added')
      }), !!subtitles.length && /*#__PURE__*/_jsx(Grid, {
        as: "ul",
        spacing: "s",
        hasBottomSpacing: true,
        children: subtitles.map(function (subtitleFile) {
          return /*#__PURE__*/_jsx(GridItem, {
            as: "li",
            mSize: "1/2",
            children: /*#__PURE__*/_jsx(SubtitlesItem, {
              isDisabled: isDisabled,
              subtitleFile: subtitleFile,
              isMutable: true,
              onDelete: removeSubtitle,
              onEdit: function onEdit() {
                return setSelectedSubtitleId(subtitleFile.id);
              }
            }, subtitleFile.id)
          }, subtitleFile.id);
        })
      }), /*#__PURE__*/_jsx(Button, {
        isDisabled: isDisabled,
        variant: variant,
        icon: "plus",
        size: "small",
        onClick: function onClick() {
          return setHasCreateSubtitlesDialog(true);
        },
        ml: variant === 'transparent' ? '-xxs' : undefined,
        children: t('actions_add_subtitles_file')
      })]
    }), hasCreateSubtitlesDialog && /*#__PURE__*/_jsx(SubtitlesEditor, {
      onCreate: addSubtitles,
      onClose: function onClose() {
        return setHasCreateSubtitlesDialog(false);
      }
    }), selectedSubtitle && /*#__PURE__*/_jsx(SubtitlesEditor, {
      assetId: assetId,
      subtitleFile: selectedSubtitle,
      onUpdate: updateSubtitles,
      onClose: function onClose() {
        return setSelectedSubtitleId(null);
      }
    })]
  }));
};
export default SubtitlesField;